// @flow
import React from 'react';
import { NullState } from 'bench-internal-theme';
import { WrappedSpinner } from 'spinner';
import AddonsTab from './AddonsTab';
import type { Addon } from '../types';
import { GET_ADDONS } from '../queries';
import { useClient } from '../../ClientContext';
import { useQuery } from '@apollo/client';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

type AddonsTabContainerProps = {
  search: string,
  isSorting: boolean,
  clearFiltersForSorting: () => void,
};

const AddonsTabContainer = ({
  search,
  isSorting,
  clearFiltersForSorting,
}: AddonsTabContainerProps) => {
  const searchAddons = (addons: Array<Addon>): Array<Addon> => {
    if (search) {
      return addons.filter(addon => addon.name.toLowerCase().includes(search.toLowerCase()));
    }

    return addons;
  };

  const client = useClient();

  const { loading, error, data } = useQuery(GET_ADDONS, {
    variables: { clientId: client?.id },
  });

  if (error) {
    return (
      <NullState
        bigEmoji="🙈"
        description={error.message}
        title="Uh oh! The following error was encountered while fetching the data for this page."
      />
    );
  }
  if (loading) {
    return <WrappedSpinner />;
  }
  const addons = (data && data.addons && searchAddons(data.addons)) || [];

  return (
    <DndProvider backend={HTML5Backend}>
      <AddonsTab
        addons={addons}
        canSort={data?.addons?.length > 1}
        search={search}
        isSorting={isSorting}
        clearFiltersForSorting={clearFiltersForSorting}
      />
    </DndProvider>
  );
};

export default AddonsTabContainer;
